import { supabase } from "./supabase";

const currentSessionSignOutOptions = { scope: "local" } as const;

/**
 * Signs out only the active browser session.
 *
 * Supabase defaults `signOut()` to global revocation, which can invalidate
 * other active sessions for the same user.
 * @returns Supabase sign-out result
 */
export function signOutCurrentSession() {
  return supabase.auth.signOut(currentSessionSignOutOptions);
}
